// extracted by mini-css-extract-plugin
export default {"root":"Pill_root__Xtmyx","outline":"Pill_outline__lnbtA","dashed":"Pill_dashed__hkHG1"};